import { useQuery } from "@tanstack/react-query";

import { authApi } from "@/api/services";

/**
 * Hook to check if single organization SSO is available (for on-premise/closed-network)
 * @returns Query with SAML URL if single organization with SSO exists, null otherwise
 */
export const useSingleOrganizationSaml = () => {
  return useQuery({
    queryKey: ["single-organization-saml"],
    queryFn: () => authApi.getSingleOrganizationSaml(),
    // NOTE: Disable automatic refetching as this is a one-time check
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    retry: false,
  });
};
